export enum ProductKind {
  PRODUCT = 'product',
  SERVICE = 'service',
  PACKAGE = 'package',
}
export const ProductKinds = [
  ProductKind.PRODUCT,
  ProductKind.SERVICE,
  ProductKind.PACKAGE,
];
